/**
 * Build a print/PDF filename from receipt fee data.
 * Format: StudentName_MonthName_BillNumber
 */
export const buildReceiptDocumentTitle = (feeData) => {
    const studentName = (feeData?.studentName || feeData?.student?.name || 'Student')
        .replace(/\s+/g, '_');
    const month = (feeData?.month || 'FeeReceipt')
        .replace(/\s+/g, '_')
        .replace(/\//g, '-');
    const billNumber = feeData?.billNumber;

    if (billNumber != null && billNumber !== '') {
        return `${studentName}_${month}_${billNumber}`;
    }
    return `${studentName}_${month}`;
};

/**
 * Map a saved fee record (from API) to receipt preview/print data.
 */
export const extractLatestReceiptData = (feeRecord, sclassesList) => {
    if (!feeRecord?.feeDetails?.length) return null;

    const latestDetail = feeRecord.feeDetails[feeRecord.feeDetails.length - 1];
    const classRef = feeRecord.student?.sclassName;
    const classId = typeof classRef === 'object' ? classRef?._id : classRef;
    const foundClass = sclassesList?.find((c) => c._id === classId);

    return {
        studentName: feeRecord.student?.name || '---',
        rollNum: feeRecord.student?.rollNum || '---',
        className: foundClass
            ? foundClass.sclassName
            : (feeRecord.student?.sclassName?.sclassName || '---'),
        month: latestDetail.month,
        amount: latestDetail.amount,
        grossAmount: latestDetail.grossAmount,
        advanceUsed: latestDetail.advanceUsed,
        monthlyAmount: latestDetail.monthlyAmount,
        duesAmount: latestDetail.duesAmount,
        discount: latestDetail.discount || 0,
        status: latestDetail.status,
        paidAmount: latestDetail.paidAmount,
        description: latestDetail.description,
        paymentDate: latestDetail.paymentDate,
        billNumber: latestDetail.billNumber
    };
};
